import React, { useContext, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Box, Button, Icon } from "@material-ui/core";
import { formatPriceWithCountry } from "../../util/util-ems";
import { AuthContext } from "../../../../core/providers/AuthContext";
import ProductImage from "../ProductImage";
import ProductQuickViewModal from "../ProductQuickViewModal";
import FilterAdminBadge from "../filters/FilterAdminBadge";
import useInfo from "../../store/hooks/useInfo";
import useCart from "../../store/hooks/useCart";
import { isArray, isEmpty, isNil } from "lodash";
import { EMPLOYEE_STORE_SHOPPING_CART_ROUTE } from "../../routes/EmployeeStoreRouter";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { BUTTONS_HEIGHT } from "../ProductActions";

const useStyles = makeStyles((theme) => ({
  productImage: {
    width: 80,
    height: 80,
    objectFit: "cover",
  },
  productInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  quantityButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 60,
    padding: theme.spacing(0.5),
    backgroundColor: `${theme.palette.primary.main}DD`,
    color: theme.palette.primary.contrastText,
    borderRadius: 8,
    marginLeft: "8px",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  buyAgainButton: {
    marginBottom: theme.spacing(1),
  },
  viewItemButton: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  buyAgainBtn: {
    height: BUTTONS_HEIGHT,

    backgroundColor: "transparent",
    border: `2px solid ${theme.palette.primary.main}`,
    color: `${theme.palette.primary.main}`,
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "transparent",
      border: `2px solid ${theme.palette.primary.main}`,
      color: `${theme.palette.primary.main}`,
      transform: "scale(1.02)",
    },
  },
  adminItems: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    gap: 6,
  },
  itemAlreadyInCart: {
    height: BUTTONS_HEIGHT,
    backgroundColor: "transparent",
    border: `2px solid ${theme.palette.text.primary}`,
    color: `${theme.palette.text.primary}`,
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "transparent",
      border: `2px solid ${theme.palette.text.primary}`,
      color: `${theme.palette.text.primary}`,
      transform: "scale(1.02)",
    },
  },
}));

const commonIconStyles = {
  width: "auto",
  height: "auto",
  padding: 1,
};

const HistoryItemContainerDetails = (props) => {
  const { title, purchasePrice, purchaseQuantity, ean, catalogCode } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const { auth } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const { isEmsAdmin } = useInfo();
  const { cartItems } = useCart();
  let history = useHistory();

  const isProductInCart = useMemo(() => {
    return (
      !isNil(cartItems) &&
      !isEmpty(cartItems) &&
      isArray(cartItems) &&
      cartItems.some((x) => x?.ean === ean)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={2}>
        <ProductImage {...props} />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.productInfo}>
        <Typography variant="h6">{title}</Typography>
        {isEmsAdmin && (
          <Box className={classes.adminItems}>
            <Typography variant="subtitle1">{`EAN: ${ean} | CAT: ${catalogCode}`}</Typography>

            <FilterAdminBadge showOnlyAdmin={true} />
          </Box>
        )}
        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant="subtitle1">
            {formatPriceWithCountry({
              price: purchasePrice,
              country: auth?.emsCountry,
            })}
          </Typography>
          <div className={classes.quantityButton}>x{purchaseQuantity}</div>
        </Box>
      </Grid>
      {isProductInCart ? (
        <Button
          className={classes.itemAlreadyInCart}
          onClick={() => history.push(EMPLOYEE_STORE_SHOPPING_CART_ROUTE)}
          startIcon={<Icon className="fas fa-shopping-cart" />}
        >
          <Typography className={classes.typo}>
            {t("EMPLOYEE_STORE.IN_CART")}
          </Typography>
        </Button>
      ) : (
        <Button
          className={classes.buyAgainBtn}
          onClick={() => setOpen(true)}
          startIcon={
            <Icon className="fas fa-cart-plus" style={commonIconStyles} />
          }
        >
          Volver a comprar
        </Button>
      )}

      <ProductQuickViewModal
        product={props}
        open={Boolean(open)}
        onClose={() => setOpen(false)}
      />
    </Grid>
  );
};

export default HistoryItemContainerDetails;
